import { render } from "./ZonesSettings.vue?vue&type=template&id=2d93d9d2&scoped=true"
import script from "./ZonesSettings.vue?vue&type=script&lang=js"
export * from "./ZonesSettings.vue?vue&type=script&lang=js"

import "./ZonesSettings.vue?vue&type=style&index=0&id=2d93d9d2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d93d9d2"]])

export default __exports__